import React from 'react';
import {
	Modal as MuiModal,
	Fade,
	Box,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import FullScreenDialog from './FullScreenDialog';

interface ModalProps {
	open: boolean;
	handleClose: () => void;
	children: React.ReactNode;
	sx?: any;
	disableBackdropClose?: boolean;
	disableFullScreen?: boolean;
	title?: string;
}

const Modal: React.FC<ModalProps> = ({
	open,
	handleClose,
	children,
	sx = {},
	disableBackdropClose = false,
	disableFullScreen = false,
	title,
}) => {
	const onClose = disableBackdropClose ? undefined : handleClose;

	const theme = useTheme();
	const mobileBreakpoint = useMediaQuery(theme.breakpoints.down('sm'));

	if (!disableFullScreen && mobileBreakpoint) {
		return (
			<FullScreenDialog
				open={open}
				handleClose={handleClose}
				title={title}
				children={children}
			/>
		);
	}
	return (
		<MuiModal
			open={open}
			onClose={onClose}
			disableEscapeKeyDown={disableBackdropClose}
		>
			<Fade
				in={open}
				timeout={{
					enter: 500,
					exit: 0,
				}}
			>
				<Box
					sx={{
						position: 'absolute',
						top: '50%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						minWidth: mobileBreakpoint ? 0 : 400,
						bgcolor: 'background.paper',
						boxShadow: 24,
						p: mobileBreakpoint ? 2 : 3,
						borderRadius: 4,
						maxHeight: mobileBreakpoint
							? 'calc(100% - 32px)'
							: '90vh',
						padding: mobileBreakpoint ? '16px' : '32px',
						overflow: 'auto',
						...sx,
					}}
				>
					{children}
				</Box>
			</Fade>
		</MuiModal>
	);
};

export default Modal;
